(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function connectHeroMotion() {
    var hero = document.querySelector('[data-ccf-future-hero]');
    if (!hero || reducedMotion.matches || !window.matchMedia('(pointer: fine)').matches) return;
    if (hero.dataset.ccfFutureMotion === 'true') return;
    hero.dataset.ccfFutureMotion = 'true';
    var frame = 0;
    var nextX = 0;
    var nextY = 0;

    function paint() {
      frame = 0;
      hero.style.setProperty('--future-x', nextX.toFixed(2) + 'px');
      hero.style.setProperty('--future-y', nextY.toFixed(2) + 'px');
    }

    hero.addEventListener('pointermove', function (event) {
      var rect = hero.getBoundingClientRect();
      nextX = ((event.clientX - rect.left) / rect.width - 0.5) * 12;
      nextY = ((event.clientY - rect.top) / rect.height - 0.5) * 12;
      if (!frame) frame = window.requestAnimationFrame(paint);
    }, { passive: true });

    hero.addEventListener('pointerleave', function () {
      nextX = 0;
      nextY = 0;
      if (!frame) frame = window.requestAnimationFrame(paint);
    }, { passive: true });
  }

  function connectReveals() {
    var targets = document.querySelectorAll(
      '.ccf-path-card, .ccf-dynamic-products .card-wrapper, .featured-collection .card-wrapper, .ccf-category-tile, .ccf-sale-mini-product'
    );
    if (!targets.length) return;

    targets.forEach(function (target, index) {
      if (target.dataset.ccfFutureReveal === 'true') return;
      target.dataset.ccfFutureReveal = 'true';
      target.classList.add('ccf-future-reveal');
      target.style.transitionDelay = Math.min(index % 8, 7) * 45 + 'ms';
    });

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      targets.forEach(function (target) {
        target.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });

    targets.forEach(function (target) {
      if (!target.classList.contains('is-visible')) observer.observe(target);
    });
  }

  function decorateStudioProducts() {
    document.querySelectorAll('[data-ccf-studio-product]').forEach(function (product) {
      if (product.querySelector('.ccf-future-product__open')) return;
      var open = document.createElement('span');
      open.className = 'ccf-future-product__open';
      open.setAttribute('aria-hidden', 'true');
      open.innerHTML = '&nearr;';
      product.appendChild(open);
    });
  }

  function tuneWelcomeOffer() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      host.style.setProperty('--forms-accent-color', '#246f8e', 'important');
      host.style.setProperty('--forms-discount-code-color', '#174d66', 'important');
      host.style.setProperty('--body-text-color', '#5d5f59', 'important');
      host.style.setProperty('--heading-text-color', '#183d50', 'important');
      host.style.setProperty('--form-text-color', '#292a27', 'important');
      host.style.setProperty('--form-background-color', '#fffdf9', 'important');
      host.style.setProperty('--button-text-color', '#ffffff', 'important');
      host.style.setProperty('--button-background-color', '#246f8e', 'important');
      host.style.setProperty('--button-close-background-color', '#efe7dc', 'important');
      host.style.setProperty('--button-close-color', '#183d50', 'important');
      host.style.setProperty('--container-background-color', '#f6f1e8', 'important');
      host.style.setProperty('--form-field-border-radius', '8px', 'important');
      host.style.setProperty('--button-border-radius', '8px', 'important');
      host.style.setProperty('--container-border-radius', '16px', 'important');
      host.style.setProperty('--container-shadow', '0 20px 56px rgba(41,42,39,.18)', 'important');
    });
  }

  function connectSearchShortcut() {
    if (document.documentElement.dataset.ccfSearchShortcut === 'true') return;
    document.documentElement.dataset.ccfSearchShortcut = 'true';
    document.addEventListener('keydown', function (event) {
      if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey) return;
      var target = event.target;
      if (target && target.matches('input, textarea, select, [contenteditable="true"]')) return;
      var search = document.querySelector('.ccf-header-search__input');
      if (!search || search.offsetParent === null) return;
      event.preventDefault();
      search.focus();
    });
  }

  function init() {
    document.documentElement.classList.add('ccf-future-ready');
    connectHeroMotion();
    connectReveals();
    decorateStudioProducts();
    tuneWelcomeOffer();
    connectSearchShortcut();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  var observer = new MutationObserver(function () {
    window.requestAnimationFrame(function () {
      connectReveals();
      decorateStudioProducts();
      tuneWelcomeOffer();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', init);
})();
